export const HeaderTableListPrices = [
    { title: 'Fert', classname: 'text-start' },
    { title: 'Cantidad', classname: 'ta-c' },
    { title: 'Descripción', classname: 'ta-c' },
    { title: 'Familia', classname: 'ta-c' },
    { title: 'Categoría', classname: 'ta-c' },
    { title: 'UMB', classname: 'ta-c' },
    { title: 'Unidades por UMB', classname: 'ta-c' },
    { title: 'PVP unitario', classname: 'ta-c' },
    { title: 'PVP caja', classname: 'ta-c' },
    { title: 'Margen mayorista', classname: 'ta-c' },
    { title: 'Precio mayorista inc. IVA', classname: 'ta-c' },
    { title: 'Precio unitario mayorista inc. IVA', classname: 'ta-c' },
    { title: 'Compra mínima', classname: 'ta-c' },
    { title: 'Descuento del mes', classname: 'ta-c' },
    { title: 'Precio Mayorista con descuento Inc. IVA', classname: 'ta-c color-yellow' },
    { title: 'Precio Mayorista unitario con descuento Inc. IVA', classname: 'ta-c' },
    { title: 'Precio Mayorista con pago anticipado inc. IVA', classname: 'ta-c' }
  ];


  export const HeaderTableListPromotions = [
    { title: 'Marca', classname: 'text-start' },
    { title: 'Categoría', classname: 'ta-c' },
    { title: 'Promoción', classname: 'ta-c' },
    { title: 'Desct.', classname: 'ta-c' },
    { title: 'Productos participantes', classname: 'ta-c' },
    { title: '¿Qué se bonifica?', classname: 'ta-c' },
    { title: 'Restricciones', classname: 'ta-c' },
    { title: 'Mecánica', classname: 'ta-c' }
  ];
  export const HeaderTableClient = [
    { title: 'Razón Social', classname: 'text-start' },
    { title: 'Código', classname: 'ta-c' },
    { title: 'Distrito', classname: 'ta-c' },
    { title: 'Contacto', classname: 'ta-c' },
    { title: 'Teléfono', classname: 'ta-c' },
    { title: 'Grupo de Precios', classname: 'text-start' },
    { title: 'Seleccionar', classname: 'ta-c' },
  ];

  export const PaymentMethodList = [
    { name: 'ZPAN', code: 'Z0PA' },
    { name: 'ZPED', code: 'C000' },
    { name: 'ZPED', code: 'C003' },
    { name: 'ZPED', code: 'C004' },
    { name: 'ZPED', code: 'C005' },
    { name: 'ZPED', code: 'C007' },
    { name: 'ZPED', code: 'C008' },
    { name: 'ZPED', code: 'C010' },
    { name: 'ZPED', code: 'C014' },
    { name: 'ZPED', code: 'C015' },
    { name: 'ZPED', code: 'C017' },
    { name: 'ZPED', code: 'C020' },
    { name: 'ZPED', code: 'C021' },
    { name: 'ZPED', code: 'C028' },
    { name: 'ZPED', code: 'C030' },
    { name: 'ZPED', code: 'C040' },
    { name: 'ZPED', code: 'C045' },
    { name: 'ZPED', code: 'C050' },
    { name: 'ZPED', code: 'C060' },
    { name: 'ZPED', code: 'C065' },
    { name: 'ZPED', code: 'C067' },
    { name: 'ZPED', code: 'C070' },
    { name: 'ZPED', code: 'C075' },
    { name: 'ZPED', code: 'C080' },
    { name: 'ZPED', code: 'C082' },
    { name: 'ZPED', code: 'C085' },
    { name: 'ZPED', code: 'C090' },
    { name: 'ZPED', code: 'C100' },
    { name: 'ZPED', code: 'C110' },
    { name: 'ZPED', code: 'C115' },
    { name: 'ZPED', code: 'C120' },
    { name: 'ZPED', code: 'C135' },
    { name: 'ZPED', code: 'C150' },
    { name: 'ZPED', code: 'C155' },
    { name: 'ZPED', code: 'C180' },
    { name: 'ZPED', code: 'C210' },
    { name: 'ZPED', code: 'C270' },
    { name: 'ZPED', code: 'Z000' },
    { name: 'ZPED', code: 'Z00E' },
  ];
  
   export const  StatusListBinnacle = [
    { label: 'Seleccionar todo', value: 'all', checked: false },
    { label: 'Por iniciar', value: 'Por iniciar', checked: false },
    { label: 'Con retraso', value: 'Con retraso', checked: false },
    { label: 'En proceso', value: 'En proceso', checked: false },
    { label: 'Finalizado', value: 'Finalizado', checked: false },
    { label: 'En pausa', value: 'En pausa', checked: false },
    { label: 'Desestimado', value: 'Desestimado', checked: false },
  ];
    export const VisibilityList = [
    { label: 'Seleccionar todo', value: 'all', checked: false },
    { label: 'Con visibilidad', value: true, checked: false },
    { label: 'Sin visibilidad', value: false, checked: false },
  ];

  // Cabeceras de  mis reclamos
   export const ColumnsReconsiderations = [
      { key: "claimId", label: "Código", width: "110px" },
      { key: "businessName", label: "Negocio", width: "140px" },
      { key: "status", label: "Estado", width: "120px" },
      { key: "caseDescription", label: "Descripción del caso", width: "260px" },
      { key: "benefitDate", label: "Mes/Año del beneficio", width: "163px" },
      { key: "category", label: "Categoría", width: "130px" },
      { key: "invoice", label: "Factura", width: "110px" },
      { key: "sapOrderNumber", label: "Pedido SAP", width: "130px" },
      { key: "amountWithoutIGV", label: "Monto solicitado sin IGV", width: "240px" },
      { key: "stage", label: "Etapa del reclamo", width: "160px" },
      { key: "finalEvaluation", label: "Evaluación final", width: "165px" },
      { key: "creditNote", label: "Nota de crédito", width: "140px" },
      { key: "approvedAmountWithoutIGV", label: "Monto aprobado sin IGV", width: "170px" },
      { key: "entryDate", label: "Fecha de ingreso del reclamo", width: "180px" }
    ];
    // productos 
    export const ColumnsProducts = [
      { key: "claimId", label: "Código", width: "110px" },
      { key: "businessName", label: "Negocio", width: "140px" },
      { key: "status", label: "Estado", width: "120px" },
      { key: "reason", label: "Motivo del reclamo", width: "200px" },
      { key: "caseDescription", label: "Descripción del caso", width: "260px" },
      { key: "sku", label: "SKU", width: "90px" },
      { key: "quantity", label: "Cantidad", width: "130px" },
      { key: "amountWithoutIGV", label: "Monto solicitado sin IGV", width: "240px" },
      { key: "invoice", label: "Factura", width: "110px" },
      { key: "stage", label: "Etapa del reclamo", width: "160px" },
      { key: "finalEvaluation", label: "Evaluación final", width: "165px" },
      { key: "creditNote", label: "Nota de crédito", width: "140px" },
      { key: "approvedAmountWithoutIGV", label: "Monto aprobado sin IGV", width: "170px" },
      { key: "entryDate", label: "Fecha de ingreso del reclamo", width: "180px" }
    ];
    // servicios 
   export const ColumnsServices = [
      { key: "claimId", label: "Código", width: "110px" },
      { key: "businessName", label: "Negocio", width: "140px" },
      { key: "status", label: "Estado", width: "120px" },
      { key: "caseDescription", label: "Descripción del caso", width: "260px" },
      { key: "benefitDate", label: "Mes/Año del beneficio", width: "163px" },
      { key: "category", label: "Categoría", width: "130px" },
      { key: "invoice", label: "Factura", width: "110px" },
      { key: "sapOrderNumber", label: "Pedido SAP", width: "130px" },
      { key: "amountWithoutIGV", label: "Monto solicitado sin IGV", width: "240px" },
      { key: "stage", label: "Etapa del reclamo", width: "160px" },
      { key: "finalEvaluation", label: "Evaluación final", width: "165px" },
      { key: "creditNote", label: "Nota de crédito", width: "140px" },
      { key: "approvedAmountWithoutIGV", label: "Monto aprobado sin IGV", width: "170px" },
      { key: "entryDate", label: "Fecha de ingreso del reclamo", width: "180px" }
    ];
    export const vendorExtraColumns = [
      { key: "closeDate", label: "Fecha de cierre del reclamo", width: "170px" },
      { key: "durationDays", label: "Tiempo", width: "100px" }
    ];